<div
  class="post-escalation-button-wrapper"
  (click)="onButtonClick()"
  [ngClass]="productDescription ? '' : 'max-height-button'"
>
  <div>
    <ds-icon
      name="{{ iconType }}"
      [size]="'24'"
      class="post-escalation-button-left-icon"
    ></ds-icon>
    <div class="product-container">
      <p class="product-name button-font">{{ productName }}</p>
      <p *ngIf="productDescription" class="product-description">
        {{ productDescription }}
      </p>
    </div>
  </div>
  <ds-icon name="chevron-right" size="24"></ds-icon>
</div>
